require('./script.js');
import '../sass/style.scss'